"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DateProvider_1 = require("@zapier/date/dist/components/DateProvider");
const getClientTimeZone_1 = __importDefault(require("@zapier/date/dist/utils/getClientTimeZone"));
const formatDateTime_1 = __importDefault(require("@zapier/date/dist/utils/formatDateTime"));
const DateTime = (props) => {
    const { date, format } = props;
    // Get timezone from AppProvider (if exists)
    const { timezone } = DateProvider_1.useDate();
    // fallback to client timezone then to UTC if that fails
    const clientTimezone = (props.ignoreProfileTimezone ? null : timezone) ||
        getClientTimeZone_1.default() ||
        'UTC';
    const formattedDate = formatDateTime_1.default(date, format || 'default', clientTimezone);
    const formattedISODate = formatDateTime_1.default(date, 'dateString', clientTimezone);
    return (react_1.default.createElement("time", { dateTime: formattedISODate, title: formattedDate }, formattedDate));
};
exports.default = DateTime;
